// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--aMuPd";
export var closeButton = "alert-module--close-button--WuHJR";
export var closeButtonWrapper = "alert-module--close-button-wrapper--U04fg";
export var error = "alert-module--error--1+E1s";
export var messageWrapper = "alert-module--message-wrapper--ObUtE";
export var open = "alert-module--open--su2+f";
export var success = "alert-module--success--CtTeH";
export var warning = "alert-module--warning--Hagf2";